import {Exchange} from "app/instruments/exchange/Exchange";
import {AsxInstrumentUtil} from "./asx/AsxInstrumentUtil";

export class SecurityUtil {

    public static underlying(code: string): string {
        return code.substring(0, 3);
    }

    public static isEquity(code: string): boolean {
        return AsxInstrumentUtil.isEquity(code);
    }

    public static isOption(code: string): boolean {
        return AsxInstrumentUtil.isOption(code);
    }

    public static isIndex(underlying: string): boolean {
        return AsxInstrumentUtil.isIndex(underlying);
    }

    /** @deprecated - Shouldn't really be needed, but we don't return exchanges on all data yet */
    public static guessExchange(code: string): Exchange {
        return AsxInstrumentUtil.guessExchange(code);
    }
}
